export default __webpack_public_path__ + "static/media/NI.f2672841.svg";